var FSGridSnippet = {};
export default FSGridSnippet;

/** @type {Array} */
FSGridSnippet.bulkActionRequestPool = [];
FSGridSnippet.bulkActionRequestTimeout = null;
FSGridSnippet.grids = {};
FSGridSnippet.inited = false;

FSGridSnippet.initAll = function()
{
    $('.fs-grid-snippet').each(function(){
        FSGridSnippet.init('#' + $(this).attr('id'));
    });
};

FSGridSnippet.init = function (gridId)
{
    // init logging
    FSGridSnippet.logStart('init');

    // update GUI config
    FSGridSnippet.loadConfig(gridId);

    // apply GUI config
    FSGridSnippet.applyConfig(gridId);

    // filter to ribbon
    FSGridSnippet.filterToRibbon();

    // init forms - filters etc.
    FSGridSnippet.initForms(gridId);

    // columns resizable
    FSGridSnippet.initColumnsResizable(gridId);

    // IE
    FSGridSnippet.fixBrowserCompatibility(gridId);

    // checkboxes (shift selecting etc.)
    FSGridSnippet.initCheckboxes(gridId);

    // skip other inits - they are already initialized
    if (FSGridSnippet.grids[gridId].inited == true){
        FSGridSnippet.fire(gridId, 'ready');
        FSGridSnippet.logEnd('init');
        return;
    }
    FSGridSnippet.grids[gridId].inited = true;

    // config save event
    FSGridSnippet.saveConfig(gridId);

    // modal action
    FSGridSnippet.initModalAction(gridId);

    // bulk action
    FSGridSnippet.initBulkAction(gridId);

    // handle confirm action
    FSGridSnippet.initHandleConfirmAction(gridId);

    // init filters
    FSGridSnippet.initFilters(gridId);

    // bulk without dialog
    FSGridSnippet.initBulkActionWithoutDialog(gridId);

    // highlighting row
    FSGridSnippet.highlightingRow(gridId);

    // init paging
    FSGridSnippet.initLinks(gridId);

    // init column sorting
    FSGridSnippet.initSorting(gridId);

    // init grid export
    FSGridSnippet.initExport(gridId);

    // fire API events
    FSGridSnippet.fire(gridId, 'ready');
    FSGridSnippet.inited = true;

    FSGridSnippet.logEnd('init');
};

FSGridSnippet.loadGrid = function(gridId, url, data, json)
{
    FSGridSnippet.logStart('loadGridFnc');

    var snippetArea = '#snippet-' + gridId.substr(6) + '-GridSnippet';
    var config = FSGridSnippet.grids[gridId].config;

    if (config.bulkAction && config.bulkAction.state != 'close') FSGridSnippet.refreshDialogByDilogState('close', gridId);
    $('#grid_filter_to_ribbon').html($('.ribbon .tab-pane.active > ul .ribbon-grid-filter-group').detach());

    $.ajax({
        url: url,
        type: (typeof data != 'undefined' ? 'POST' : 'GET'),
        data: (typeof data != 'undefined' ? data : null),
        contentType: (typeof json != 'undefined' ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8'),
        beforeSend: function(){ waiter_close('body'); waiter_open('medium', snippetArea); FSGridSnippet.logStart('loadGridAjax'); },
        error: function(jqXHR){ FSGridSnippet.logEnd('loadGridAjax'); waiter_close(snippetArea); if (jqXHR.readyState == 0 && jqXHR.status == 0) return; alert(FSGridSnippet.grids[gridId].config.errorMessage); },
        success: function (payload)
        {
            FSGridSnippet.logEnd('loadGridAjax');
            waiter_close(snippetArea);
            if(payload.snippets){ FSGridSnippet.logStart('loadGridDOM'); for (var id in payload.snippets){ if (payload.snippets[id].indexOf(gridId.substring(1) + '-advancedFilters') == -1) document.getElementById(id).innerHTML = payload.snippets[id]; else $('#' + id).html(payload.snippets[id]); } FSGridSnippet.logEnd('loadGridDOM'); FSGridSnippet.init(gridId); }
            if(payload.msg){ alert(payload.msg); FSGridSnippet.filterToRibbon(); }
        },
        off: ['unique']
    });

    FSGridSnippet.logEnd('loadGridFnc');
};

FSGridSnippet.loadConfig = function(gridId)
{
    FSGridSnippet.logStart('loadConfig');

    // load grid settings from html page
    var addToConfig = $(gridId).data('clientsideconfig');

    if (typeof FSGridSnippet.grids[gridId] === 'undefined'){
        FSGridSnippet.grids[gridId] = {};
        FSGridSnippet.grids[gridId].config = {};
    }else if (FSGridSnippet.grids[gridId].config['filterId'] != addToConfig['filterId'] || addToConfig['isFirstStateResetted'] || !addToConfig['isJsActive']){
        FSGridSnippet.grids[gridId].config['sorting'] = [];
        FSGridSnippet.grids[gridId].config['columnFilters'] = [];
    }

    var config = FSGridSnippet.grids[gridId].config;

    for (var key in addToConfig){
        config[key] = addToConfig[key];
    }

    // load grid settings from browser
    if (FSGridSnippet.grids[gridId].inited != true){
        var addToConfig = window.localStorage.getItem(gridId);
        if (addToConfig){
            addToConfig = JSON.parse(addToConfig);
            if (config['filterId'] != addToConfig['filterId'] || config['isFirstStateResetted'] || !config['isJsActive']){
                addToConfig['sorting'] = [];
                addToConfig['columnFilters'] = [];
            }
            delete addToConfig['filterId'];
            for (var key in addToConfig){
                config[key] = addToConfig[key];
            }
        }
    }

    // fill grid data
    config['gridData'] = $(gridId + '-body tbody tr');

    // set variables to defaults if they are not set
    config['sorting'] = config['sorting'] || [];
    config['columnFilters'] = config['columnFilters'] || [];
    config['columnWidths'] = config['columnWidths'] || {};
    config['filterId'] = config['filterId'] || null;
    config['sortingCache'] = [];
    if (config.hasBulkAction){
        config['bulkAction'] = config['bulkAction'] || {
            state: 'close',
            sidebar: false,
            panels: {},
            css: {
                'height': $(gridId + '-bulk-action-dialog').data('minheight'),
                'width': $(gridId + '-bulk-action-dialog').data('minwidth')
            }
        };
        config['bulkAction'].panels = config['bulkAction'].panels || {};
        config['bulkAction'].state = 'close';
    }

    // set persistent variables which are saved to browser
    config['persistent'] = ['bulkAction', 'columnWidths', 'sorting', 'filterId', 'columnFilters'];

    FSGridSnippet.logEnd('loadConfig');
};

FSGridSnippet.saveConfig = function(gridId)
{
    $(window).on('beforeunload', function(event) {
        var config = FSGridSnippet.grids[gridId].config;
        var configToSave = {};
        for (var i in config.persistent) {
            configToSave[config.persistent[i]] = config[config.persistent[i]];
        }
        window.localStorage.setItem(gridId, JSON.stringify(configToSave));
    });
};

FSGridSnippet.applyConfig = function(gridId)
{
    FSGridSnippet.logStart('applyConfig');

    var config = FSGridSnippet.grids[gridId].config;

    // sorting
    if (config.isJsActive && config.sorting.length){
        FSGridSnippet.applySorting(gridId);
    }

    // column filters
    if (config.isJsActive && config.columnFilters.length){
        for (var i in config.columnFilters){
            if (config.columnFilters[i]){
                var input = $(gridId + '-body thead th input[data-filter="'+config.columnFilters[i].name+'"]');
                if (input.length){
                    $(gridId + '-body thead th input[data-filter="'+config.columnFilters[i].name+'"]').val(config.columnFilters[i].value)
                }else{
                    config.columnFilters = [];
                    $(gridId + '-body thead th input').val('');
                    return;
                }
            }
        }
        $(gridId + '-body thead [data-filter]').toggle();
        FSGridSnippet.applyFilters(gridId);
    }

    FSGridSnippet.logEnd('applyConfig');
};

FSGridSnippet.initForms = function(gridId)
{
    FSGridSnippet.logStart('initForms');

    $(gridId + ' form').each(function(){
        Nette.initForm($(this)[0]);
    });
    $('#filterQuickFormRibbon').each(function(){
        Nette.initForm($(this)[0]);
    });
    if (FSGridSnippet.grids[gridId].config['filterBefore'] == true){
        FSGridSnippet.fire(gridId, 'filters.ready');
    }

    FSGridSnippet.logEnd('initForms');
};

FSGridSnippet.initLinks = function(gridId)
{
    FSGridSnippet.logStart('initLinks');

    // general links
    $(document).on('click', gridId + '-content a.grid-ajax, ' + gridId + '-advancedFilters a.grid-ajax', function(event){
        event.preventDefault();
        $('.advancedFilter').modal('hide');
        FSGridSnippet.loadGrid(gridId, $(this).attr('href'));
    });

    // filter to ribbon
    if (FSGridSnippet.inited == false) $(document).on('click', '.ribbon .grid-ajax', function(event){
        event.preventDefault();
        FSGridSnippet.loadGrid(gridId, $(this).attr('href'));
    });

    // responsive links
    $(document).on('click', gridId + '-body .details-show-switcher .glyphicon', function(event){
        event.preventDefault();
        $(this).parent().parent().toggleClass('details-show');
        $(this).toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
    });

    FSGridSnippet.logEnd('initLinks');
};

/**
 * @param gridId
 */
FSGridSnippet.initCheckboxes = function(gridId)
{
    FSGridSnippet.logStart('initCheckboxes');

    $(gridId + '-body table').checkboxes('range', true);

    FSGridSnippet.logEnd('initCheckboxes');
};


/**
 * @param gridId
 */
FSGridSnippet.highlightingRow = function(gridId)
{
    FSGridSnippet.logStart('highlightingRow');

    $(document).on('click', gridId + '-body tbody tr', function()
    {
        if ($(this).hasClass('higlighted')){
            $(this).removeClass('higlighted');
        }else{
            $(gridId + '-body tbody tr.higlighted').removeClass('higlighted');
            $(this).addClass('higlighted');
        }
    });

    FSGridSnippet.logEnd('highlightingRow');
};

/**
 * Setup columns resizable.
 */
FSGridSnippet.initColumnsResizable = function(gridId)
{
    FSGridSnippet.logStart('initColumnsResizable');

    var config = FSGridSnippet.grids[gridId].config;

    if (isLayoutMobile()) return;

    $(gridId + '-body th[data-sorting_type=Icon]').each(function(){
        var name = $(this).attr('id').replace('drag-table-', '');
        addStylesheetRule(gridId + '-body tbody td.grid-cell-'+name+', ' + gridId + '-body thead th.grid-header-'+name+' { width: '+ (($(this).children('span').width() || 0) + 80) +'px; text-align: center; flex-grow: 0 }');
    });

    if(config && config.columnsResizable == true)
    {
        $(gridId + '-body th[id]').resizable({
            handles: "e",
            minWidth: 50,
            aspectRatio: false,
            start: function( event, ui){
                ui.element.css('flex-grow', '0');
            },
            stop: function( event, ui ){
                var name = ui.element.attr('id').replace('drag-table-', '');
                var width = ui.element.outerWidth();
                ui.element.width('');
                addStylesheetRule(gridId + '-body tbody td.grid-cell-'+name+', ' + gridId + '-body thead th.grid-header-'+name+' { width: '+ width +'px; flex-grow: 0 }');
                FSGridSnippet.fixBrowserCompatibility(gridId);
                config.columnWidths[name] = width;
            }
        });

        for(var name in config.columnWidths ){
            addStylesheetRule(gridId + '-body tbody td.grid-cell-'+name+', ' + gridId + '-body thead th.grid-header-'+name+' { width: '+ config.columnWidths[name] +'px; flex-grow: 0 }');
        }
    }

    FSGridSnippet.logEnd('initColumnsResizable');
};

/**
 * Action modal
 */

FSGridSnippet.initModalAction = function(gridId)
{
    FSGridSnippet.logStart('initModalAction');

    $(document).on('click', gridId + '-content .grid-action-btn', function()
    {
        FSGridSnippet.processModalAction(gridId, $(this).data('handleonclick'), $(this).data('target'));
    });

    FSGridSnippet.logEnd('initModalAction');
};

FSGridSnippet.processModalAction = function(gridId, url, modalTarget)
{
    FSGridSnippet.logStart('processModalAction');

    var modalFade = $(modalTarget);
    var modalDialog = modalFade.find('.modal-dialog:eq(0)');

    // prepare Ajax request
    var req =
    {
        url: url,
        beforeSend: function()
        {
            FSGridSnippet.logStart('processModalActionAjax');
            modalDialog.html('<div/>');
            waiter_open('large');
        },
        success: function(data, textStatus, jqXHR)
        {
            FSGridSnippet.logEnd('processModalActionAjax');
            FSGridSnippet.logStart('processModalActionDOM');
            if (jqXHR.responseJSON)
            {
                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
                modalFade.modal('hide');
            }
            else
            {
                modalDialog.html(data);
                modalFade.modal('handleUpdate');
                FSForms.init();
            }
            FSGridSnippet.logEnd('processModalActionDOM');
        },
        error: function(data, textStatus, jqXHR)
        {
            flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
            modalFade.modal('hide');
        },
        statusCode:
        {
            500: function()
            {
                flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
            }
        },
        complete: function(jqXHR, textStatus)
        {
            waiter_close();
        }
    };

    // send Ajax request
    $.ajax(req);

    FSGridSnippet.logEnd('processModalAction');
};

/** BULK ACTIONS ******************************************************************************************************/

/**
 * Inits bulk action for grid with id.
 * @param id
 */
FSGridSnippet.initBulkAction = function(gridId)
{
    FSGridSnippet.logStart('initBulkAction');

    var config = FSGridSnippet.grids[gridId].config;
    if (!config.hasBulkAction) return;

    $(document).on('click', gridId + '-body .grid-bulk-action-head', FSGridSnippet.onClickHeadCheckbox); // add event on head checkbox
    $(document).on('change', gridId + '-body .grid-bulk-action-cell', FSGridSnippet.onClickCellCheckbox); // add event on cell checkbox
    $(document).on('click', gridId + '-bulk-action-dialog .btn-close', FSGridSnippet.onClickButtonClose); // add event on button close on dialog
    $(document).on('click', '#sidebarRight-sidebar .btn-close', FSGridSnippet.onClickButtonClose); // add event on button close on dialog
    $(document).on('click', '#sidebarRight-sidebar-close-button', FSGridSnippet.onClickButtonCloseSidebar); // add event on button close on dialog
    $(document).on('click', gridId + '-bulk-action-dialog .btn-min', FSGridSnippet.onClickButtonMin); // add event on button min on dialog
    $(document).on('click', gridId + '-bulk-action-dialog .btn-link', FSGridSnippet.onClickButtonLock); // add event on button lock on dialog
    $(document).on('click', '#sidebarRight-sidebar-unlock-button', FSGridSnippet.onClickButtonUnlock); // add event on button unlock on dialog
    $(document).on('click', '.grid-actionBulkAction', FSGridSnippet.onClickToggleSelectionMode); // add event on button lock on dialog
    $(document).on('click', '.grid-actionBulkActionPanelButton', FSGridSnippet.onClickButtonActionMobile); // add event on button lock on dialog
    $(document).on('click', '.bulk_dialog_show_hide_panel_button', FSGridSnippet.bulkDialogPanelSwitch);
    $(document).on('click', '.grid-bulk-content .bulk-form-button .ribbon-button', FSGridSnippet.bulkFormButtonClick);

    // prepare bulk request pull
    if(Array.isArray(FSGridSnippet.bulkActionRequestPool[gridId]) == false)
    {
        FSGridSnippet.bulkActionRequestPool[gridId] = [];
    }

    FSGridSnippet.logEnd('initBulkAction');
};

/**
 * This method open bulk dialog and send AJAX request.
 * @param gridId
 */
FSGridSnippet.processBulkAction = function(gridId)
{
    FSGridSnippet.logStart('processBulkAction');

    var config = FSGridSnippet.grids[gridId].config;
    var length = $(gridId + '-body .grid-bulk-action-cell:checked').length;

    if(length > 0 && config.bulkAction.state == 'close')
    {
        this.refreshDialogByDilogState('open', gridId);
        this.sendBulkActionRequest(gridId);
    }
    else if(length > 0 && config.bulkAction.state == 'min')
    {
        this.sendBulkActionRequest(gridId);
    }
    else if(length > 0 && config.bulkAction.state == 'open')
    {
        this.sendBulkActionRequest(gridId);
    }
    else if(length == 0)
    {
        this.refreshDialogByDilogState('close', gridId);
        FSGridSnippet.abortAllBulkActionRequest(gridId);
    }

    FSGridSnippet.logEnd('processBulkAction');
};

/**
 * This method open/close parts of bulk dialog.
 */
FSGridSnippet.bulkDialogPanelSwitch = function()
{
    FSGridSnippet.logStart('bulkDialogPanelSwitch');

    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
    var target = $(this).data('target');
    var config = FSGridSnippet.grids[gridId].config;
    var id = $(this).data('bulkstate');

    if (target){
        var area = $('#'+$(this).data("target"));
    }else{
        var area = $(this).parent().parent().find(".panel-body");
    }

    area.toggle();
    $(this).children('span').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');

    config.bulkAction.panels[id] = area.is(':visible');

    FSGridSnippet.logEnd('bulkDialogPanelSwitch');
};

/**
 * This method open/close parts of bulk dialog from memory.
 * @param gridId
 */
FSGridSnippet.bulkDialogPanelSwitchInit = function()
{
    FSGridSnippet.logStart('bulkDialogPanelSwitchInit');

    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
    var config = FSGridSnippet.grids[gridId].config;

    $('.bulk_dialog_show_hide_panel_button').each(function()
    {
        var id = $(this).data('bulkstate');

        if (typeof config.bulkAction.panels[id] != 'undefined' && config.bulkAction.panels[id] == false){
            $(this).trigger('click');
        }
    });

    FSGridSnippet.logEnd('bulkDialogPanelSwitchInit');
};

/**
 * @param {String} state
 * @param {String} gridId
 */
FSGridSnippet.refreshDialogByDilogState = function(stateDialog, gridId, sidebar)
{
    FSGridSnippet.logStart('refreshDialogByDilogState');

    var config = FSGridSnippet.grids[gridId].config;
    var dialog = $(gridId + '-bulk-action-dialog');

    if (typeof sidebar == 'boolean'){
        config.bulkAction.sidebar = sidebar;
    }

    // open dialog
    if(stateDialog == 'open' || stateDialog == 'max')
    {
        config.bulkAction.state = 'open';

        dialog.removeClass('minimized');

        $('.grid-actionBulkActionPanel').removeClass('hidden');

        if (config.bulkAction.sidebar == true){
            if (dialog.is(':visible')) dialog.hide();
            var title = dialog.find('.panel-title').text();
            $('#vertical_right_text_sidebar strong, #sidebarRight-sidebar-title strong').text(title);

            showSidebarRight();
            return;
        }

        if (!$('#sidebarRight-sidebar').hasClass('hidden')){
            hideSidebarRight();
        }

        dialog.css(config.bulkAction.css);

        var fixPosition = function ()
        {
            dialog.css({
                'top': 'auto',
                'left': 'auto',
                'bottom': Math.max($(window).height() - dialog.offset().top - dialog.outerHeight(), 0) + 'px',
                'right': Math.max($(window).width() - dialog.offset().left - dialog.outerWidth(), 0) + 'px',
                'max-height': 'calc(100vh - ' + Math.max($(window).height() - dialog.offset().top - dialog.outerHeight(), 0) + 'px)',
                'max-width': 'calc(100vw - ' + Math.max($(window).width() - dialog.offset().left - dialog.outerWidth()) + 'px)'
            });
        };
        var preparePosition = function()
        {
            dialog.css({
                top: dialog.position().top,
                left: dialog.position().left,
                bottom: 'auto',
                right: 'auto'
            });
        };
        dialog.draggable({
            cancel: '.draggableOff',
            containment: 'document',
            start: preparePosition,
            stop: fixPosition
        });
        dialog.resizable({
            handles: 'all',
            containment: 'document',
            create: function(event, ui)
            {
                $('.ui-icon-gripsmall-diagonal-se').remove();
            },
            start: preparePosition,
            stop: fixPosition
        });
        // set icon
        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');
        dialog.show('slow');
    }
    // close dialog
    else if (stateDialog == 'close')
    {
        config.bulkAction.state = 'close';

        dialog.find('.panel-body').html('');
        $('.grid-actionBulkActionPanel').addClass('hidden');
        $('#sidebarRight-sidebar').removeClass('sidebarRight-sidebar-visible');
        $('#sidebarLeft-sidebar, #sidebarLeft-content').removeClass('responsive-hidden');

        if (config.bulkAction.sidebar == true || !$('#sidebarRight-sidebar').hasClass('hidden')){
            hideSidebarRight();
            return;
        }

        if (dialog.is(':visible') && !dialog.hasClass('minimized')) {
            config.bulkAction.css = {
                'height': dialog.css('height'),
                'width': dialog.css('width')
            };
        }

        dialog.hide('slow');
    }
    // min
    else if (stateDialog == 'min')
    {
        var prevCSS = {
            'height': dialog.css('height'),
            'width': dialog.css('width')
        };

        // invert color
        dialog.addClass('minimized');

        // change icon
        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-up"></span>');

        // disable resizable
        dialog.resizable('destroy');

        // css
        dialog.css({
            'height': 'auto'
        });

        config.bulkAction.css = prevCSS;
        config.bulkAction.state = 'min';
    }

    FSGridSnippet.logEnd('refreshDialogByDilogState');
};

/** Bulk action - handles - begin *************************************************************************************/

/**
 * Callback on click head checkbox.
 */
FSGridSnippet.onClickHeadCheckbox = function()
{
    FSGridSnippet.logStart('onClickHeadCheckbox');

    var gridId = FSGridSnippet.getGridId($(this));
    $(gridId + '-body .grid-bulk-action-cell').prop('checked', $(this).prop('checked')); // toggle checked cell checkboxs
    FSGridSnippet.processBulkAction(gridId);

    FSGridSnippet.logEnd('onClickHeadCheckbox');
};

/**
 * Callback on click checkbox in cell.
 */
FSGridSnippet.onClickCellCheckbox = function()
{
    FSGridSnippet.logStart('onClickCellCheckbox');

    FSGridSnippet.processBulkAction(FSGridSnippet.getGridId($(this)));

    FSGridSnippet.logEnd('onClickCellCheckbox');
};

/**
 * Callback on click button close in bulk dialog.
 */
FSGridSnippet.onClickButtonClose = function()
{
    FSGridSnippet.logStart('onClickButtonClose');

    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
    FSGridSnippet.refreshDialogByDilogState('close', gridId);
    $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
    $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
    $('.fs-grid-snippet').removeClass('selection-active');

    FSGridSnippet.logEnd('onClickButtonClose');
};

/**
 * Callback on click button close in sidebar dialog.
 */
FSGridSnippet.onClickButtonCloseSidebar = function()
{
    FSGridSnippet.logStart('onClickButtonCloseSidebar');

    $('.grid-bulk-action-dialog .btn-close').trigger('click');

    FSGridSnippet.logEnd('onClickButtonCloseSidebar');
};

/**
 *
 */
FSGridSnippet.onClickButtonMin = function()
{
    FSGridSnippet.logStart('onClickButtonMin');

    var gridId = FSGridSnippet.getGridId($(this));
    var config = FSGridSnippet.grids[gridId].config;

    if(config.bulkAction.state == 'open')
    {
        FSGridSnippet.refreshDialogByDilogState('min', gridId);
    }
    else if(config.bulkAction.state == 'min')
    {
        FSGridSnippet.refreshDialogByDilogState('max', gridId);
    }

    FSGridSnippet.logEnd('onClickButtonMin');
};

/**
 *
 */
FSGridSnippet.onClickButtonLock = function()
{
    FSGridSnippet.logStart('onClickButtonLock');

    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
    FSGridSnippet.refreshDialogByDilogState('open', gridId, true);
    FSGridSnippet.sendBulkActionRequest(gridId);

    FSGridSnippet.logEnd('onClickButtonLock');
};

/**
 *
 */
FSGridSnippet.onClickButtonActionMobile = function()
{
    FSGridSnippet.logStart('onClickButtonActionMobile');

    FSGridSnippet.onClickButtonLock();
    $('#sidebarRight-sidebar').addClass('sidebarRight-sidebar-visible');
    $('#sidebarLeft-sidebar, #sidebarLeft-content').addClass('responsive-hidden');

    FSGridSnippet.logEnd('onClickButtonActionMobile');
};

/**
 *
 */
FSGridSnippet.onClickToggleSelectionMode = function()
{
    FSGridSnippet.logStart('onClickToggleSelectionMode');

    var gridId = FSGridSnippet.getGridId($(this));

    $(gridId + '-content').toggleClass('selection-active');
    if (!$(gridId + '-content').hasClass('selection-active')){
        $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
        $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
        $('.grid-actionBulkActionPanel').addClass('hidden');
    }

    FSGridSnippet.logEnd('onClickToggleSelectionMode');
};

/**
 *
 */
FSGridSnippet.onClickButtonUnlock = function()
{
    FSGridSnippet.logStart('onClickButtonUnlock');

    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
    FSGridSnippet.refreshDialogByDilogState('open', gridId, false);
    FSGridSnippet.sendBulkActionRequest(gridId);

    FSGridSnippet.logEnd('onClickButtonUnlock');
};

/**
 *
 */
FSGridSnippet.addBulkActionsCloseButton = function()
{
    FSGridSnippet.logStart('addBulkActionsCloseButton');

    $('#sidebarRight-sidebar-title .bulk_dialog_show_hide_panel_button').remove();
    if ($('#sidebarRight-sidebar-content #bulk_actions').length > 0){
        $('#sidebarRight-sidebar-title').append('<div class = "bulk_dialog_show_hide_panel_button close" data-bulkstate = "bulk_actions" data-target = "bulk_actions"><span class="bulk_edit_form bulk_dialog_show_hide_panel_glyphicon glyphicon glyphicon-chevron-up"></span></div>');
    }

    FSGridSnippet.logEnd('addBulkActionsCloseButton');
};

/** Bulk action - handles - end ***************************************************************************************/

/**
 * Sends Ajax request for bulk action.
 * @param gridId
 * @param dialogId
 * @param primaryKeys
 */
FSGridSnippet.sendBulkActionRequest = function(gridId)
{
    FSGridSnippet.logStart('sendBulkActionRequest');

    var gridId = gridId;
    var config = FSGridSnippet.grids[gridId].config;
    var target = (config.bulkAction.sidebar == true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body');
    var unTarget = (config.bulkAction.sidebar != true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body');

    $(target).html('<div/>');
    $(unTarget).html('<div/>');
    waiter_open('medium', target);

    if (FSGridSnippet.bulkActionRequestTimeout){
        clearTimeout(FSGridSnippet.bulkActionRequestTimeout);
    }

    FSGridSnippet.bulkActionRequestTimeout = setTimeout(function()
    {
        var state = {'bulkAction': {'selectedRows': []}};
        $(gridId + '-body .grid-bulk-action-cell:checked').each(function () {
            state.bulkAction.selectedRows.push($(this).data('primarykey'));
        });

        if (state.bulkAction.selectedRows.length == 0) {
            FSGridSnippet.refreshDialogByDilogState('close', gridId);
            $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
            $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
            return;
        }

        // abort all prev request
        FSGridSnippet.abortAllBulkActionRequest(gridId);

        // prepare Ajax request
        var req =
            {
                method: 'POST',
                url: $(gridId + '-bulk-action-dialog').data('handleonclick'),
                data: state,
                beforeSend: function (jqXHR) {
                    // adds current request into pool
                    FSGridSnippet.bulkActionRequestPool[gridId].push(jqXHR);
                },
                success: function (data, textStatus, jqXHR) {
                    waiter_close();
                    if (jqXHR.responseJSON) {
                        flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
                        $(gridId + '-bulk-action-dialog .btn-close').click();
                    }
                    else {
                        $(target).html(data);
                        $(target).find('form').each(function () {
                            window.Nette.initForm(this);
                        });
                        FSGridSnippet.bulkDialogPanelSwitchInit();
                    }
                    FSGridSnippet.addBulkActionsCloseButton();
                },
                error: function (jqXHR) {
                    if (jqXHR.statusText == 'abort') {
                        return;
                    }
                    else if ($(gridId + '-bulk-action-dialog').data('errormsg')) {
                        flashMessageWarning($(gridId + '-bulk-action-dialog').data('errormsg'));
                        $(gridId + '-bulk-action-dialog .btn-close').click();
                    }
                },
                statusCode:
                    {
                        500: function () {
                            flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
                        }
                    },
            };

        // send Ajax request
        $.ajax(req);

    }, 10);

    FSGridSnippet.logEnd('sendBulkActionRequest');
};

/**
 * Aborts all request for bulk action.
 * @param dialogId
 */
FSGridSnippet.abortAllBulkActionRequest = function(dialogId)
{
    FSGridSnippet.logStart('abortAllBulkActionRequest');

    FSGridSnippet.bulkActionRequestPool[dialogId].forEach(function(jqXHR, index)
    {
        jqXHR.abort();
        FSGridSnippet.bulkActionRequestPool[dialogId].splice(index, 1);
    });

    FSGridSnippet.logEnd('abortAllBulkActionRequest');
};

/** HANDLE CONFIRM ACTIONS ********************************************************************************************/

/**
 * @param string gridId
 */
FSGridSnippet.initHandleConfirmAction = function(gridId)
{
    FSGridSnippet.logStart('initHandleConfirmAction');

    var options = {};
    $(gridId + '-body .grid-cell-action-confirm-handle').popover(options);

    FSGridSnippet.logEnd('initHandleConfirmAction');
};

/** INIT FILTERS ********************************************************************************************/
FSGridSnippet.initFilters = function(gridId)
{
    FSGridSnippet.logStart('initFilters');

    var config = FSGridSnippet.grids[gridId].config;
    if(config && config.filterBefore == true)
    {
        $('.advancedFilter').modal('show');
    }

    $(document).on('click', gridId + '-body .filter_head_cell', function (event){
        event.preventDefault();
        $(gridId + '-body thead [data-filter]').toggle();
        $(this).parent().find('input').focus();
    });

    if (FSGridSnippet.inited == false) $(document).on('submit', '.filterQuickForm', function(event){
        event.preventDefault();
        FSGridSnippet.loadGrid(gridId, $(this).attr('action'), $(this).serialize());
    });

    var timeout = null;
    $(document).on('input change', gridId + '-body [data-filter]', function(event){
        event.preventDefault();
        if (timeout){ clearTimeout(timeout); }
        timeout = setTimeout(function(){ FSGridSnippet.applyFilters(gridId); }, 200);
    });

    if (FSGridSnippet.inited == false) $(document).on('click', '.openFiltersModal', function(event){
        event.preventDefault();
        if (!$('.advancedFilter').length){
            $.ajax({
                url: $(this).attr('href'),
                beforeSend: function(){ waiter_open('large'); },
                success: function (payload)
                {
                    FSGridSnippet.logStart('initFiltersDOM');
                    if(payload.snippets){ for (var id in payload.snippets){ $('#' + id).html(payload.snippets[id]); } }
                    FSGridSnippet.logEnd('initFiltersDOM');
                    FSGridSnippet.logStart('initFiltersForm');
                    FSForms.init();
                    FSGridSnippet.logEnd('initFiltersForm');
                    FSGridSnippet.fire(gridId, 'filters.ready');
                    $('.advancedFilter').modal('show');
                },
                complete: function(){ waiter_close(); }
            });
        }else{
            $('.advancedFilter').modal('show');
        }
    });

    FSGridSnippet.logEnd('initFilters');
};

/** Bulk action without dialog - start ********************************************************************************/
FSGridSnippet.initBulkActionWithoutDialog = function(gridId)
{
    FSGridSnippet.logStart('initBulkActionWithoutDialog');

    // toggle checked cell checkboxs
    $(document).on('click', gridId + '-content .action-bulk-without-dialog-head-cell', function()
    {
        $(gridId + '-content .action-bulk-without-dialog-body-cell').prop('checked', $(this).prop('checked'));
    });

    // handle button form multi actions
    $(document).on('click', gridId + '-content .action-bulk-without-dialog-multi-actions-send-btn', function()
    {
        // selected rows
        var ids = FSGridSnippet.bulkActionWithoutDialogGetIds(gridId);

        // link for action
        var link = $(gridId + '-content .action-bulk-without-dialog-multi-actions-select-action').val();

        // redirect
        if(ids.length != 0)
        {
            window.location.replace(link + '&' + $.param({ids: ids}))
        }
        else
        {
            alert('Není vybrán žádný řádek.');
        }
    });

    // handle button form single action
    $(document).on('click', gridId + '-content .action-bulk-without-dialog-single-action', function()
    {
        // selected rows
        var ids = FSGridSnippet.bulkActionWithoutDialogGetIds(gridId);

        // link for action
        var link = $(gridId + '-content .action-bulk-without-dialog-single-action').data('link');

        // redirect
        if(ids.length != 0)
        {
            window.location.replace(link + '&' + $.param({ids: ids}))
        }
        else
        {
            alert('Není vybrán žádný řádek.');
        }
    });

    $(document).off('click', '.grid-actionBulkAction').on('click', '.grid-actionBulkAction', FSGridSnippet.onClickToggleSelectionMode); // add event on button lock on dialog

    FSGridSnippet.logEnd('initBulkActionWithoutDialog');
};

/**
 * @param gridId
 * @return {Array}
 */
FSGridSnippet.bulkActionWithoutDialogGetIds = function(gridId)
{
    FSGridSnippet.logStart('bulkActionWithoutDialogGetIds');

    var ids = [];
    $(gridId + '-body .action-bulk-without-dialog-body-cell:checked').each(function()
    {
        ids.push($(this).data('primarykey'));
    });

    FSGridSnippet.logEnd('bulkActionWithoutDialogGetIds');

    return ids;
};
/** Bulk action without dialog - end **********************************************************************************/

/**
 *
 */
FSGridSnippet.bulkFormButtonClick = function(event)
{
    FSGridSnippet.logStart('bulkFormButtonClick');

    event.preventDefault();
    $(this).closest('form').submit();

    FSGridSnippet.logEnd('bulkFormButtonClick');
};

FSGridSnippet.applyFilters = function(gridId)
{
    FSGridSnippet.logStart('applyFilters');

    var i = 1;
    var config = FSGridSnippet.grids[gridId].config;
    config.columnFilters = [];

    $(gridId + '-body thead th').each(function(){
        var input = $(this).find('[data-filter]');
        var filterValue = $(this).find('[data-filter]').val();
        if (filterValue){
            config.columnFilters[i] = {
                'name': input.data('filter'),
                'value': input.val().toLowerCase(),
                'type': $(this).data('sorting_type')
            };
            $(this).addClass('filtering-active');
        }else{
            $(this).removeClass('filtering-active');
        }
        i++;
    });

    if (config.columnFilters.length == 0){
        config.numberRowsFiltered = config.gridData.length;
        config.gridData.removeClass('filtered');
    }else{
        config.numberRowsFiltered = config.gridData.addClass('filtered').filter(function(){
            for (var i in config.columnFilters){
                if (config.columnFilters[i].type == 'Icon'){
                    if (($(this.children[i-1].querySelector('[title]')).attr('title') || '').toLowerCase() != config.columnFilters[i].value){
                        return false;
                    }
                }else{
                    if (this.children[i-1].innerText.toLowerCase().indexOf(config.columnFilters[i].value) == -1) {
                        return false;
                    }
                }
            }
            return true;
        }).removeClass('filtered').length;
    }

    $(gridId + '-content .grid-total-count').text(config.numberRowsFiltered);
    $(gridId + '-content .grid-count-displayed').text((config.numberRowsFiltered ? '1 - ' + config.numberRowsFiltered : 0));

    FSGridSnippet.logEnd('applyFilters');
};

FSGridSnippet.applySorting = function(gridId)
{
    FSGridSnippet.logStart('applySorting');

    var config = FSGridSnippet.grids[gridId].config;
    $(gridId + '-body thead th').removeClass('sorted-asc sorted-desc multiple-sorted');
    $(gridId + '-body thead .badge').remove();

    // reset sorting when no sorting is active
    if (!config.sorting.length){
        config.gridData.css('order', '');
        return;
    }

    // prepare sorting definition
    var sortingToPrepare = [];
    for (var i in config.sorting){
        var th = $(gridId + '-body thead .grid-header-'+config.sorting[i].name);
        var index = $(gridId + '-body thead th').index(th);

        if (!th.length){
            config.sorting = [];
            return;
        }

        th.addClass('sorted-' + config.sorting[i].order);
        config.sorting[i].index = index;
        config.sorting[i].type = th.data('sorting_type');
        config.sorting[i].settings = th.data('sorting_settings');

        if (config.sorting.length > 1){
            $(gridId + '-body thead .grid-header-'+config.sorting[i].name+' .sorting_head_cell.sorting_inactive[data-sorting_order=desc]').before('<span class="badge">'+(parseInt(i)+1)+'</span>');
            $(gridId + '-body thead .grid-header-'+config.sorting[i].name).addClass('multiple-sorted')
        }

        if (typeof config.sortingCache[index] == 'undefined'){
            if (config.sorting[i].type == null){
                config.sorting[i].type = 'Number';
            }
            sortingToPrepare[i] = config.sorting[i];
        }else{
            config.sorting[i].type = config.sortingCache[index];
        }
        if (config.sorting[i].type == 'DateTime'){
            config.sorting[i].settings = FSGridSnippet.convertDateFormat(config.sorting[i].settings);
        }
    }

    // prepare data for sorting
    if (sortingToPrepare.length) {
        config.gridData.each(function () {
            if (!Array.isArray(this.sortKey)) this.sortKey = [];
            for (var i in sortingToPrepare) {
                var index = config.sorting[i].index;
                if (config.sorting[i].type == 'Icon'){
                    this.sortKey[index] = $(this.children[index].querySelector('[title]')).attr('title') || '';
                }else{
                    this.sortKey[index] = this.children[index].innerText;
                }
                if (config.sorting[i].type == 'Number') {
                    if (this.sortKey[index] != '' && parseInt(this.sortKey[index]) != this.sortKey[index]) config.sorting[i].type = 'String';
                }
                if (config.sorting[i].type == 'DateTime') {
                    this.sortKey[index] = (this.sortKey[index] == '' ? 0 : moment(this.sortKey[index], config.sorting[i].settings).unix());
                }
            }
        });
        for (var i in config.sorting){
            config.sortingCache[config.sorting[i].index] = config.sorting[i].type;
        }
    }

    // sort data
    config.gridData.sort(function(a, b) {
        var result;
        for (var i in config.sorting) {
            var index = config.sorting[i].index;
            if (config.sorting[i].type == 'Number' || config.sorting[i].type == 'DateTime') {
                if (config.sorting[i].order == 'asc') {
                    result = a.sortKey[index] - b.sortKey[index];
                } else {
                    result = b.sortKey[index] - a.sortKey[index];
                }
            } else {
                if (config.sorting[i].order == 'asc') {
                    result = a.sortKey[index].localeCompare(b.sortKey[index]);
                } else {
                    result = b.sortKey[index].localeCompare(a.sortKey[index]);
                }
            }
            if (result != 0) break;
        }
        return result;
    });

    // update table by sorting result
    config.gridData.each(function(index){
        this.style.order = index;
    });

    FSGridSnippet.logEnd('applySorting');
};

FSGridSnippet.filterToRibbon = function()
{
    FSGridSnippet.logStart('filterToRibbon');

    var toRibbon = $('#grid_filter_to_ribbon .ribbon-grid-filter-group');

    if (toRibbon.length){
        $('.ribbon .tab-pane.active > ul').append(toRibbon.detach());

        FSGridSnippet.logStart('filterToRibbon-gridRender');
        $(window).trigger('resize');
        FSGridSnippet.logEnd('filterToRibbon-gridRender');
    }

    FSGridSnippet.logEnd('filterToRibbon');
};

FSGridSnippet.sortingByColumn = function(gridId, name, order)
{
    FSGridSnippet.logStart('sortingByColumn');

    var data = {
        name: name,
        order: order
    };
    var link = FSGridSnippet.grids[gridId].config.sortUrl;

    FSGridSnippet.loadGrid(gridId, link, JSON.stringify({ sendJSON: data }), true);

    FSGridSnippet.logEnd('sortingByColumn');
};


FSGridSnippet.fixBrowserCompatibility = function(gridId)
{
    FSGridSnippet.logStart('fixBrowserCompatibility');

    //IE fix (IE doesn't support sticky position)
    if (!(typeof CSS != "undefined" && CSS.supports && CSS.supports("position", "sticky")))
    {
        var timeout = null;
        var head = document.querySelector(gridId + '-body thead');
        var icons = document.querySelectorAll(gridId + '-body .grid-action, ' + gridId + '-body thead .grid-header-actions, ' + gridId + '-body thead .grid-header-bulk-action');

        $(gridId + '-body tbody').off('scroll').on('scroll', function(event)
        {
            if (event.target.scrollLeft != head.scrollLeft){
                head.scrollLeft = event.target.scrollLeft;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(function(){ for (let i = 0; i < icons.length; i++){ icons[i].style.left = event.target.scrollLeft + 'px' } }, 50);
            }
        });

        var scrollWidth = 0, tbody = document.querySelector(gridId + '-body tbody');
        if (tbody) scrollWidth = tbody.scrollWidth;
        if (scrollWidth) addStylesheetRule(gridId + '-body tr { width: ' + scrollWidth + 'px }');
    }

    FSGridSnippet.logEnd('fixBrowserCompatibility');
};

FSGridSnippet.initSorting = function(gridId)
{
    FSGridSnippet.logStart('initSorting');

    $(document).on('click', gridId + '-body thead .sorting_inactive', function(event){
        event.preventDefault();
        var config = FSGridSnippet.grids[gridId].config;

        if (!config.isJsActive){
            FSGridSnippet.sortingByColumn(gridId, $(this).data('sorting_column'), $(this).data('sorting_order'));
            return;
        }

        if (event.shiftKey == false && event.ctrlKey == false){
            config.sorting = [];
        }else{
            for (var i in config.sorting) if (config.sorting[i].name == $(this).data('sorting_column')) config.sorting.splice(i, 1);
        }

        config.sorting.push ({
            name: $(this).data('sorting_column'),
            order: $(this).data('sorting_order')
        });

        FSGridSnippet.applySorting(gridId);
    });

    $(document).on('click', gridId + '-body thead .sorting_active', function(event){
        event.preventDefault();
        var config = FSGridSnippet.grids[gridId].config;

        if (!config.isJsActive){
            FSGridSnippet.sortingByColumn(gridId, $(this).data('sorting_column'), $(this).data('sorting_order'));
            return;
        }

        if (event.shiftKey == false && event.ctrlKey == false){
            config.sorting = [];
        }else{
            for (var i in config.sorting) if (config.sorting[i].name == $(this).data('sorting_column')) config.sorting.splice(i, 1);
        }

        FSGridSnippet.applySorting(gridId);
    });

    FSGridSnippet.logEnd('initSorting');
};

FSGridSnippet.initExport = function(gridId)
{
    FSGridSnippet.logStart('initExport');

    $(document).on("submit", gridId + '-exportForm', function(event)
    {
        event.preventDefault();
        waiter_close();

        if($(gridId+'-exportForm [name=format]').val() == 'pdf' || FSGridSnippet.grids[gridId].config.isExportEncrypted == true)
        {
            $(gridId+'-exportSettings .settingsPdf').toggle($(gridId+'-exportForm [name=format]').val() == 'pdf');
            $(gridId+'-exportSettings .settingsPsw').toggle(FSGridSnippet.grids[gridId].config.isExportEncrypted == true);
            $(gridId+'-exportSettings').modal('toggle');
        }else{
            $(gridId+'-exportForm [name=password]').val('');
            FSGridSnippet.preProcessExport(gridId);
        }
    });

    $(document).on("click", gridId+'-exportConfirmDialog-yes', function ()
    {
        waiter_open('large');
        FSGridSnippet.processExport(gridId);
    });

    $(document).on("click", gridId+'-exportSettings-yes', function ()
    {
        if (FSGridSnippet.grids[gridId].config.isExportEncrypted == true)
        {
            var psw1 = $(gridId + '-exportSettings [name=psw1]').val();
            var psw2 = $(gridId + '-exportSettings [name=psw2]').val();

            if (psw1 != psw2 || psw1 == '' || psw2 == '') {
                alert(FSGridSnippet.grids[gridId].config.errorPswMessage);
                return;
            } else {
                $(gridId + '-exportForm [name=password]').val(psw1);
            }
        }
        if($(gridId+'-exportForm [name=format]').val() == 'pdf')
        {
            $(gridId+'-exportForm [name=pdf_grid_convert_type]').val($(gridId + '-exportSettings [name=pageSize]').val());
        }

        $(gridId + '-exportSettings').modal('toggle');
        FSGridSnippet.preProcessExport(gridId);
    });

    FSGridSnippet.logEnd('initExport');
};

FSGridSnippet.processExport = function(gridId)
{
    FSGridSnippet.logStart('processExport');

    var form = $(gridId + '-exportForm > form');

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
        success: function(payload) {
            waiter_close();
            if (payload.redirect) {
                $(gridId + ' .processKeys').val('');
                window.location.href = payload.redirect;
            }else if (payload.msg) {
                alert(payload.msg);
            }else{
                alert(FSGridSnippet.grids[gridId].config.errorMessage);
            }
        }
     });

    FSGridSnippet.logEnd('processExport');
};

FSGridSnippet.preProcessExport = function(gridId)
{
    FSGridSnippet.logStart('preProcessExport');

    waiter_open('large');

    $.ajax({
        url: FSGridSnippet.grids[gridId].config.exportCountUrl,
        success: function(payload)
        {
            if(payload.count)
            {
                var selected = $(gridId + ' .processKeys').val();
                var maxCount = ($(gridId + '-exportForm > form [name=format]').val() == 'zip' ? payload.maxResultSetForZipExport : payload.maxResultSetForExport);

                if (selected){
                    payload.count = selected.split(',').length;
                }

                if(payload.count > maxCount)
                {
                    waiter_close();
                    $(gridId+'-exportConfirmDialog-count').text(maxCount);
                    $(gridId+'-exportConfirmDialog').modal('toggle');
                }
                else
                {
                    FSGridSnippet.processExport(gridId);
                }
            }
        },
        error: function()
        {
            alert(FSGridSnippet.grids[gridId].config.errorMessage);
            waiter_close();
        }
    });

    FSGridSnippet.logEnd('preProcessExport');
};

FSGridSnippet.fire = function(gridId, eventName)
{
    $(gridId).trigger('grid.' + eventName, [gridId]);
};


/** Helpers ***********************************************************************************************************/

FSGridSnippet.getGridId = function(el)
{
    return '#' + el.closest('.fs-grid-snippet').attr('id');
};

FSGridSnippet.logStart = function(logName)
{
    window.performance.mark(logName + '_start');
};

FSGridSnippet.logEnd = function(logName)
{
    window.performance.mark(logName + '_end');
    window.performance.measure(logName, logName + '_start', logName + '_end');
};

FSGridSnippet.logEcho = function()
{
    var items = window.performance.getEntriesByType('measure');
    for (var i = 0; i < items.length; ++i) {
        var req = items[i];
        console.log(req.name + ': ' + Math.round(req.duration) + 'ms');
    }
};

FSGridSnippet.convertDateFormat = function(phpFormat)
{
    var convert = {
        Y: 'YYYY',
        y: 'YY',
        m: 'MM',
        n: 'MM',
        d: 'DD',
        j: 'DD',
        H: 'HH',
        h: 'HH',
        G: 'HH',
        i: 'mm',
        s: 'ss'
    };

    var jsFormat = phpFormat;
    for (var i in convert){
        jsFormat = jsFormat.replace(i, convert[i]);
    }
    return jsFormat;
};

FSGridSnippet.refreshMainGrid = function()
{
    var id = $(document.querySelector('.fs-grid-snippet')).attr('id');
    if (id) {
        FSGridSnippet.loadGrid('#'+id, FSGridSnippet.grids['#'+id].config.loadUrl);
        return true;
    }else{
        return false;
    }
};


// WEBPACK FOOTER //
// ./client-side/GridSnippet/js/grid.js